import { Injectable } from '@angular/core';
import { BrandConfig } from '../models/brand.model';
import { BRANDS_CONFIG, DEFAULT_BRAND } from '../config/brands.config';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private brand: BrandConfig = DEFAULT_BRAND;

  constructor() {
    this.loadBrand();
  }

  private loadBrand(): void {
    const host = window.location.hostname.toLowerCase();
    this.brand = BRANDS_CONFIG[host] || DEFAULT_BRAND;

    if (this.brand.favicon) {
      this.updateFavicon(this.brand.favicon);
    }
  }

  getBrand(): BrandConfig {
    return this.brand;
  }

  get logoDark(): string {
    return this.brand.logoDark;
  }

  get logoLight(): string {
    return this.brand.logoLight;
  }

  get logoSm(): string {
    return this.brand.logoSm || this.brand.logoLight;
  }

  get logoLg(): string {
    return this.brand.logoLg || this.brand.logoLight;
  }

  get appName(): string {
    return this.brand.appName;
  }

  private updateFavicon(iconUrl: string): void {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = iconUrl;
  }
}